import { optional, required, obj } from 'AppReact/schema';

export default {
  attachment: optional('string'),
  id: optional('integer'),
  name: optional('string'),
  parent: optional('string'),
  parent_id: optional('integer'),
  confidence: required('number'),
}
